import React, {useMemo} from "react";
import {Card, Colors, IContainerProps} from "../../../ui";
import {useIsMobile} from "../../helpers";

interface IMapColorToTheme {
  color?: "purple" | "yellow" | "red" | "primary_green" | "green" | "black" | "grey";
}

interface INotificationCard extends IContainerProps, IMapColorToTheme {}

export const NotificationCard = ({color = "purple", children, sx}: INotificationCard) => {
  const isMobile = useIsMobile();

  const mapColorToTheme = useMemo(
    () => ({
      purple: Colors.secondary._100,
      yellow: Colors.orange._100,
      red: Colors.red._100,
      primary_green: Colors.primary._100,
      green: Colors.green._100,
      black: Colors.grey._1000,
      grey: Colors.grey._100,
    }),
    []
  );

  const backgroundColor = mapColorToTheme[color];

  return (
    <Card
      sx={{
        backgroundColor,
        gap: "12px",
        width: isMobile ? "100%" : "530px",
        padding: "12px",
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};
